import React, { Component } from "react";
import { isNumber } from "lodash";

export class Gift extends Component {
  constructor(props) {
    super(props);

    this.state = {
      giftAmount: 0,
      isAdded: false,
    };
  }

  handleFundAdd = () => {
    const { centralizedGift, onFundAdded } = this.props;
    const { giftAmount, isAdded } = this.state;

    if (giftAmount > 0) {
      this.setState({ isAdded: !isAdded });

      onFundAdded(centralizedGift, !isAdded, giftAmount);
    }
  };

  handleInput = (e) => {
    const { centralizedGift, onFundAdded } = this.props;
    const { isAdded } = this.state;
    const currentAmount = parseFloat(e.target.value);

    if (currentAmount >= 0) {
      if (!isAdded && currentAmount != 0) {
        this.setState({ isAdded: true });
      }

      this.setState({ giftAmount: currentAmount });

      onFundAdded(centralizedGift, true, currentAmount);
    }
  };

  render() {
    const { currencySymbol, centralizedGift } = this.props;
    const amountPlacehodler = `${currencySymbol}`;

    if (!centralizedGift) {
      return "";
    }

    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <img src={centralizedGift.get("img")} />
        </div>
        <div className="panel-body">
          <span className="fund-title pull-left">{centralizedGift.get("name")}</span>
          <div className="text-center">
            <input
              data-testid="t-Gift-number"
              className="fund-amount"
              type="number"
              placeholder={amountPlacehodler}
              onChange={this.handleInput}
            />
          </div>
          <div className="fund-added-container pull-left">
            <input
              data-testid="t-Gift-checkbox"
              className="fund-added"
              type="checkbox"
              checked={this.state.isAdded}
              onChange={this.handleFundAdd}
            />
            <span className="fund-added-text" onClick={this.handleFundAdd}>
              Add fund
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Gift;
